import React from 'react'
import createReactClass from 'create-react-class'
import {Accordion, AccordionItem} from 'react-sanfona'
import ErrorBlock from '../../elements/error-block'
import './monitoring-events-panel.scss'

export default createReactClass({
  renderEvents () {
    if (this.props.events.length > 0) {
      return this.props.events.map((event, index) => {
        return this.renderCardBody(event, index)
      })
    } else {
      return 'There are no events'
    }
  },
  renderCardBody (event, index) {
    return (
      <div className="col-md-4 event" key={index}>
        <div className="col-md-12">
          {this.getKeyValue('Event date', event.eventDate)}
        </div>
        <div className="col-md-12">
          {this.getKeyValue('Rule', event.ruleName)}
        </div>
        <div className='col-md-12'>
          {this.getKeyValue('Old', event.oldValue)}
          {this.getKeyValue('New', event.newValue, event.oldValue)}
        </div>
      </div>
    )
  },

  getKeyValue (key, val, dependentKey) {
    if (val) {
      return <span>{dependentKey ? ' - ' : null}{key}: <span className='value'>{val}</span></span>
    }
  },

  getErrorMessage (error) {
    return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  render () {
    return (
      <div>
        <Accordion>
          <AccordionItem key='monitoring-events' title='Monitoring Events' expanded={this.props.events.length > 0}>
            <div className="section-body clearfix">
              {this.props.loader
                ? <div className='loader-ctr'><span className="loading"></span></div>
                : this.props.error
                  ? <ErrorBlock {...this.props.error}/>
                  : (this.props.events
                    ? <div className={this.props.events.length > 0 ? 'events-list' : ''}>
                      {this.renderEvents()}
                    </div>
                    : null)
              }
            </div>
          </AccordionItem>
        </Accordion>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/report-page/monitoring-events-panel.js